import { documentStore } from "@/store/store";
import { PATH_TO_WIDTH_PROPERTY } from "./helpers";
import { parseFloatAndFixTo2Digits } from "@/util/math";
import { TreeNode } from "@/types/tree";

export function changeColumnWidthAndCommitToStore(
  columnId: TreeNode["id"],
  width: number
) {
  if (Number.isNaN(width)) return;

  const cleanWidth = parseFloatAndFixTo2Digits(width);

  if (cleanWidth >= 0) {
    // we use the mutation directly to avoid triggering the column's actions
    documentStore.propertyChangedMutation({
      elementId: columnId,
      path: `${PATH_TO_WIDTH_PROPERTY}`,
      value: {
        unit: "%",
        number: cleanWidth,
        style: `${cleanWidth}%`
      },
      meta: {
        snapshotLabel: "Change column's width"
      }
    });
  }
}
